import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import { Alert, Tabs, Tab, TextField, Button, Box } from "@mui/material";
import Cookie from "cookie-universal";
import { TAGS } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";

function TagsCreate() {
  const [tabIndex, setTabIndex] = useState(0);
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [slugEn, setSlugEn] = useState("");
  const [slugAr, setSlugAr] = useState("");
  const [alert, setAlert] = useState(null);
  const [alertVisible, setAlertVisible] = useState(true);

  const token = Cookie().get("dashboardLogin");
  const userRole = Cookie().get("userRole");

  // Function to generate slug from text
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-") // Replace spaces with dashes
      .replace(/[^a-zA-Z0-9\u0600-\u06FF-]+/g, ""); // Keep Arabic, Latin, numbers, and dashes
  };

  // Automatically update slugs when names change
  useEffect(() => {
    setSlugEn(generateSlug(nameEn));
  }, [nameEn]);

  useEffect(() => {
    setSlugAr(generateSlug(nameAr));
  }, [nameAr]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name_en", nameEn);
    formData.append("name_ar", nameAr);
    formData.append("slug_en", slugEn);
    formData.append("slug_ar", slugAr);

    try {
      const response = await Axios.post(`/panel/${TAGS}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Tag added successfully:", response.data);

      setNameEn("");
      setNameAr("");
      setSlugEn("");
      setSlugAr("");
      setAlert({ type: "success", message: "Tag added successfully!" });
      setAlertVisible(true);
      setTimeout(() => setAlertVisible(false), 2000);
    } catch (error) {
      console.error("Error adding Tag:", error);
      setAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to add Tag.",
      });
      setAlertVisible(true);
      setTimeout(() => setAlertVisible(false), 2000);
    }
  };

  return (
    <>
      {alert && alertVisible && (
        <Alert
          severity={alert.type}
          onClose={() => setAlertVisible(false)}
          sx={{
            transition: "opacity 1s ease-out",
            opacity: alertVisible ? 1 : 0,
          }}
        >
          {alert.message}
        </Alert>
      )}

      <Grid size={12}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ mx: "auto", p: 2, boxShadow: 3, borderRadius: 2 }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, newIndex) => setTabIndex(newIndex)}
            centered
          >
            <Tab label="Name" />
            <Tab label="الاسم" />
            <Tab label="Slug" />
            <Tab label="Slug Ar" />
          </Tabs>

          {tabIndex === 0 && (
            <TextField
              fullWidth
              margin="normal"
              label="Name"
              value={nameEn}
              onChange={(e) => setNameEn(e.target.value)}
            />
          )}
          {tabIndex === 1 && (
            <TextField
              fullWidth
              margin="normal"
              label="الاسم"
              value={nameAr}
              onChange={(e) => setNameAr(e.target.value)}
            />
          )}
          {tabIndex === 2 && (
            <TextField
              fullWidth
              margin="normal"
              label="Slug"
              value={slugEn}
              disabled
            />
          )}
          {tabIndex === 3 && (
            <TextField
              fullWidth
              margin="normal"
              label="slug Ar"
              value={slugAr}
              disabled
            />
          )}

          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ mt: 2 }}
          >
            Submit
          </Button>
        </Box>
      </Grid>
    </>
  );
}

export default TagsCreate;
